import { render, staticRenderFns } from "./exce-pc.vue?vue&type=template&id=a6191b18&scoped=true&"
import script from "./exce-pc.vue?vue&type=script&lang=js&"
export * from "./exce-pc.vue?vue&type=script&lang=js&"
import style0 from "./exce-pc.vue?vue&type=style&index=0&id=a6191b18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6191b18",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/workspace/DEPLOY/ibu-owt-core/ibu-owt-core-owt-ssr-nuxt/components/SvgIcon.vue').default})
